import { styled } from '@mui/material/styles';

const HERO_WAVE_BACKGROUND =
  "url('data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDE1MCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+PGcgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNMCAzMGwxNjAgMTMuMzc1QzMyMCA1Ni4yNSA2NDAgODMuNzUgOTYwIDk2LjYyNSAxMjgwIDExMCAxNjAwIDExMCAxNzYwIDExMGgxNjB2NDBIMFYzMHoiIG9wYWNpdHk9Ii4zMDEiLz48cGF0aCBkPSJNMCAwbDE2MCAxNi43MTlDMzIwIDMyLjgxMiA2NDAgNjcuMTg3IDk2MCA4My4yOCAxMjgwIDEwMCAxNjAwIDEwMCAxNzYwIDEwMGgxNjB2NTBIMFYweiIgb3BhY2l0eT0iLjE1Ii8+PHBhdGggZD0iTTAgNjBsMTYwIDEwLjAzMWMxNjAgOS42NTYgNDgwIDMwLjI4MSA4MDAgMzkuOTM4QzEyODAgMTIwIDE2MDAgMTIwIDE3NjAgMTIwaDE2MHYzMEgwVjYweiIvPjwvZz48L3N2Zz4=')";

export const HomeHeroSection = styled('section', {
  shouldForwardProp: prop => prop !== 'overlayHeader',
})<{ overlayHeader?: boolean }>(({ overlayHeader }) => ({
  position: 'relative',
  height: '28rem',
  overflow: 'hidden',
  marginTop: overlayHeader ? '-72px' : 0,
  '@media (min-width: 768px)': {
    height: '34rem',
  },
}));

export const HeroVideoWrap = styled('div')({
  position: 'absolute',
  inset: 0,
  zIndex: 0,
});

export const HeroVideo = styled('video')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

export const HeroOverlay = styled('div')({
  position: 'absolute',
  inset: 0,
  background: 'linear-gradient(to right, rgba(0, 0, 0, 0.5), transparent)',
});

export const HeroContent = styled('div')({
  position: 'relative',
  zIndex: 10,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  maxWidth: '1280px',
  margin: '0 auto',
  padding: '0 16px',
  '@media (min-width: 768px)': {
    padding: '0 24px',
  },
});

export const HeroTitle = styled('h1')({
  fontSize: '1.875rem',
  lineHeight: 1.2,
  fontWeight: 700,
  color: '#fff',
  margin: '0 0 5rem',
  maxWidth: '42rem',
  '@media (min-width: 768px)': {
    fontSize: '3rem',
  },
});

export const HeroWave = styled('div')({
  backgroundImage: HERO_WAVE_BACKGROUND,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  height: '60px',
  transform: 'scaleX(-1)',
});

export const HomeServiceSection = styled('section')({
  backgroundColor: '#fff',
  padding: '5rem 0',
});

export const HomeContainer = styled('div')({
  width: '100%',
  maxWidth: '72rem',
  margin: '0 auto',
  padding: '0 1rem',
  '@media (max-width: 768px)': {
    padding: '0 0.5rem',
  },
});

export const HomeServiceTitle = styled('h2')({
  margin: '0 0 1.5rem',
  color: '#1f2937',
  fontSize: '1.875rem',
  lineHeight: 1.2,
  fontWeight: 700,
  letterSpacing: '-0.025em',
  '@media (min-width: 768px)': {
    fontSize: '2.25rem',
  },
});

export const HomeServiceDescription = styled('p')({
  margin: 0,
  color: '#4b5563',
  fontSize: '1.125rem',
  lineHeight: 1.75,
});

export const HomeAdventureSection = styled('section')({
  backgroundColor: '#012F5B',
  color: '#fff',
  padding: '4rem 0',
});

export const HomeExperienceSection = styled('section')({
  backgroundColor: '#A55F1A',
  color: '#fff',
  padding: '4rem 0',
});

export const HomeAdventureTitle = styled('h2')({
  margin: '0 0 2.5rem',
  textAlign: 'center',
  fontSize: '1.875rem',
  lineHeight: 1.2,
  fontWeight: 700,
});

export const HomeAdventureContentGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '2rem',
  alignItems: 'stretch',
  '@media (min-width: 1024px)': {
    gridTemplateColumns: '1fr 1fr',
  },
});

export const HomeAdventureHtml = styled('div')({
  color: '#fff',
  '& p': {
    margin: '0 0 1rem',
    lineHeight: 1.75,
  },
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    margin: '0 0 1rem',
    color: '#fff',
  },
  '& ul, & ol': {
    margin: '0 0 1rem',
    paddingLeft: '1.25rem',
  },
  '& a': {
    color: '#fff',
    textDecoration: 'underline',
  },
});

export const HomeAdventureHighlight = styled('div')({
  height: '100%',
  padding: '2rem',
  borderRadius: '1.5rem',
  border: '5px solid rgba(255, 255, 255, 0.65)',
  boxSizing: 'border-box',
});

export const HomeAdventureHighlightHtml = styled(HomeAdventureHtml)({
  '& ul': {
    marginBottom: 0,
  },
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    fontSize: '2rem',
    lineHeight: 1.25,
    marginBottom: '1rem',
  },
  '& p, & li': {
    fontSize: '1.25rem',
    lineHeight: 1.45,
  },
  '& li': {
    padding: '3px 0',
  },
  '@media (max-width: 1024px)': {
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      fontSize: '1.75rem',
    },
    '& p, & li': {
      fontSize: '1.1rem',
    },
  },
});

export const HomeAdventureTourGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '1.5rem',
  marginTop: '4rem',
  '@media (min-width: 768px)': {
    gridTemplateColumns: '1fr 1fr',
  },
});

export const HomeAdventureTourCard = styled('article')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
});

export const HomeAdventureTourImageLink = styled('a')({
  position: 'relative',
  display: 'block',
  width: '100%',
  paddingTop: '66.6667%',
  borderRadius: '0.5rem',
  overflow: 'hidden',
});

export const HomeAdventureTourBody = styled('div')({
  padding: '1.5rem 0',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

export const HomeAdventureTourTitle = styled('h4')({
  margin: '0 0 0.5rem',
  fontSize: '1.25rem',
  lineHeight: 1.4,
  fontWeight: 700,
  color: '#fff',
});

export const HomeAdventureTourDescription = styled('p')({
  margin: '0 0 1rem',
  fontSize: '0.875rem',
  lineHeight: 1.6,
  color: '#fff',
  opacity: 0.95,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 5,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const HomeAdventureTourAction = styled('div')({
  marginTop: '0.5rem',
  alignSelf: 'flex-start',
  width: 'fit-content',
});

export const HomeEtaxiSection = styled('section')({
  backgroundColor: '#FFFFFF',
  padding: '2rem 0',
  '@media (min-width: 768px)': {
    padding: '4rem 0',
  },
});

export const HomeEtaxiLayout = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '80rem',
  margin: '0 auto',
  padding: '0 1rem',
  gap: '1.5rem',
  '@media (min-width: 768px)': {
    flexDirection: 'row',
    padding: '0 2rem',
    gap: '2rem',
  },
});

export const HomeEtaxiImageColumn = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  '@media (min-width: 768px)': {
    width: '50%',
  },
});

export const HomeEtaxiImageWrap = styled('div')({
  position: 'relative',
  width: '100%',
  maxWidth: '32rem',
  borderRadius: '1rem',
  overflow: 'hidden',
  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
  minHeight: '18rem',
  '@media (min-width: 768px)': {
    minHeight: '24rem',
  },
});

export const HomeEtaxiContentColumn = styled('div')({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  '@media (min-width: 768px)': {
    width: '50%',
  },
});

export const HomeEtaxiTitle = styled('h2')({
  margin: '1rem 0 1rem',
  color: '#A55F1A',
  textDecoration: 'underline',
  fontSize: '1.875rem',
  lineHeight: 1.2,
  fontWeight: 700,
  '@media (min-width: 768px)': {
    marginTop: '0.25rem',
    fontSize: '2.25rem',
  },
});

export const HomeEtaxiHtml = styled('div')({
  color: '#1F2937',
  fontSize: '0.875rem',
  lineHeight: 1.7,
  '@media (min-width: 768px)': {
    fontSize: '1rem',
  },
  '& p': {
    margin: '0 0 1rem',
  },
});

export const HomeEtaxiAction = styled('div')({
  paddingTop: '1.5rem',
});

export const HomeTravelGuideSection = styled('section')({
  backgroundColor: '#FFFFFF',
  padding: '4rem 0',
});

export const HomeTravelGuideHeader = styled('div')({
  textAlign: 'center',
  marginBottom: '2.5rem',
});

export const HomeTravelGuideTitle = styled('h2')({
  margin: '0 0 1rem',
  color: '#012F5B',
  fontSize: '1.875rem',
  lineHeight: 1.2,
  fontWeight: 700,
});

export const HomeTravelGuideDescription = styled('p')({
  margin: '0 auto',
  maxWidth: '42rem',
  color: '#4B5563',
  fontSize: '1rem',
  lineHeight: 1.75,
});

export const HomeTravelGuideGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '1.5rem',
  '@media (min-width: 768px)': {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
});

export const HomeTravelGuideCard = styled('article')({
  overflow: 'hidden',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const HomeTravelGuideThumbnailWrap = styled('div')({
  position: 'relative',
  height: '12rem',
  borderRadius: '0.75rem',
  overflow: 'hidden',
});

export const HomeTravelGuideBody = styled('div')({
  padding: '1.25rem 0 0',
  flexGrow: 1,
});

export const HomeTravelGuideCardTitle = styled('h3')({
  margin: '0 0 0.5rem',
  fontSize: '1.125rem',
  lineHeight: 1.5,
  fontWeight: 700,
  color: '#012F5B',
  transition: 'color 0.2s ease',
});

export const HomeTravelGuideDate = styled('p')({
  margin: '0 0 1rem',
  color: '#4B5563',
  fontSize: '0.875rem',
});

export const HomeTravelGuideExcerpt = styled('p')({
  margin: 0,
  color: '#374151',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: 1.6,
});

export const HomeTravelGuideAction = styled('div')({
  marginTop: '2.5rem',
  textAlign: 'center',
});
